import { SET_NOTIFICATION_PREFERENCE } from 'actions';
import { NotificationPreference } from 'typings';

export function setNotificationPreference(
  notificationPreference: Array<NotificationPreference>,
) {
  return { notificationPreference, type: SET_NOTIFICATION_PREFERENCE };
}
